import { faCheckCircle, faWeightScale } from "@fortawesome/pro-light-svg-icons";
import { faX } from "@fortawesome/pro-solid-svg-icons";

import { T } from "@repo/transifex";
import type { CapturedWeight } from "~/stores/kiosk-session/types";
import { formatScaleWeight, getScaleUnitLabel } from "~/utils/weight-units";

import { Modal, type ModalProps } from "../shared/modal";
import { ModalIcon } from "../shared/modal-icon";
import { ModalTitle } from "../shared/modal-title";
import { ModalButton } from "../shared/modal-button";
import { ModalButtonGroup } from "../shared/modal-button-group";

type ModalWeightCaptureProps = Pick<ModalProps, "open"> & {
  productName: string;
  /** The net reading once the scale holds still; null while waiting. */
  captured: CapturedWeight | null;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ModalWeightCapture = ({
  productName,
  captured,
  onConfirm,
  onCancel,
  open = true
}: ModalWeightCaptureProps) => {
  return (
    <Modal backdropVariant="idle" onOutsideClick={onCancel} open={open}>
      <div className="flex flex-col items-center gap-y-16 px-32 text-center">
        <ModalIcon
          icon={captured ? faCheckCircle : faWeightScale}
          variant="info"
        />

        <ModalTitle size="9xl" variant="info" weight="black">
          {captured ? (
            <T
              _str="{weight} {unit} captured!"
              weight={formatScaleWeight(captured.weight, captured.decimals)}
              unit={getScaleUnitLabel(captured.unit)}
            />
          ) : (
            <T _str="Place your item on the scale" />
          )}
        </ModalTitle>

        <p className="text-5xl font-semibold text-kiosk-text-white">
          {productName}
        </p>

        <ModalButtonGroup className="mt-16">
          {captured ? (
            <ModalButton variant="idle" onClick={onConfirm}>
              <T _str="Confirm" />
            </ModalButton>
          ) : (
            <ModalButton variant="idle" icon={faX} onClick={onCancel}>
              <T _str="Cancel" />
            </ModalButton>
          )}
        </ModalButtonGroup>
      </div>
    </Modal>
  );
};
